import { useCallback, useEffect, useState } from 'react';
import { errorMessage } from '../../lib/errors';
import { useReady } from '../../lib/session';

/** Small fetch hook for online-only administration screens. */
/** `path` null : rien à charger (ex. fiche d'un utilisateur pas encore créé). */
export function useApi<T>(path: string | null) {
  const { api } = useReady();
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const reload = useCallback(() => {
    if (!path) return;
    api.request<T>('GET', path).then(
      (d) => {
        setData(d);
        setError(null);
      },
      (e) => setError(errorMessage(e)),
    );
  }, [api, path]);
  useEffect(reload, [reload]);
  return { data, error, reload };
}

export function useMutation() {
  const { api } = useReady();
  const [error, setError] = useState<string | null>(null);
  const run = async (method: string, path: string, body?: unknown) => {
    setError(null);
    try {
      return await api.request(method, path, body);
    } catch (e) {
      setError(errorMessage(e));
      throw e;
    }
  };
  return { run, error, setError };
}
